export default "__VITE_ASSET__C8Emn3QW__"